<template>
    <b-container>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>
        <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Summary</p>
                <div class="reg-form-body">
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Personal Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.PersonalDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.PersonalDetail" style="font-size:20px;color:green"></i>
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Address Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.AddressDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.AddressDetail" style="font-size:20px;color:green"></i>
                           
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Physical Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.PhysicalDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.PhysicalDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Nominee Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.NomineeDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.NomineeDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br/>
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Family Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.FamilyDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.FamilyDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center" v-if="(getRegTyp != 0 && getRegTyp != 3) || (getRegTyp == 0 && (getExpFlg=='true' || getExpFlg==true))">
                        <div class="col-6 col-md-3 ">
                            Experience Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.ExprienceDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.ExprienceDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                       
                    </div>
                     <br  v-if="(getRegTyp != 0 && getRegTyp != 3) || (getRegTyp == 0 && (getExpFlg=='true' || getExpFlg==true))"/>
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Qualification Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.QualificationDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.QualificationDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Document Upload Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.DocumentUpload" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.DocumentUpload" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Declaration Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.DeclerationDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.DeclerationDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br />
                    <div class="row justify-content-md-center" style="display:none">
                        <div class="col-6 col-md-3 ">
                            Payment Status 
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.PaymentStatus" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.PaymentStatus" style="font-size:20px;color:green"></i>
                            
                        </div>
                    </div>
                    <br />
                    
            <b-col style="text-align:right" >
            
                <b-button 
                 type="submit"
                 variant="primary" 
                 :disabled="!form.AllowPayment"
                 @click="onClickButtonPayment">Make Payment</b-button> 
                 <span style="font-size: 0.75rem; color: red; display: block;">
                            Note: not applicable for New Profiles
                </span>
                </b-col>
                
                </div>
            </div>
          
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import FeesPaymentBD from '@/components/RegistrationDetails/FeesPaymentBD'
export default {
  components: { Spinner,FeesPaymentBD },
  data() {
    return {
      
        max:0,
        maxnew:0,
      show: true,
      counter:0,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      form: {
        PersonalDetail: false,
        AddressDetail: false,
        PhysicalDetail: false,
        NomineeDetail: false,
        FamilyDetail: false,
        ExprienceDetail: false,
        QualificationDetail: false,
        DocumentUpload: false,
        DeclerationDetail: false,
        PaymentStatus: false,
        AllowPayment: false,
      }
    };
  },
  computed: {
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      return x;
    },
    getExpFlg(){
      return this.$store.getters.getExperienceFlag;
    }
  },
  methods: {
      getProfileStatus() {
      this.max=0;
      this.maxnew= 0;
      this.counter =0;
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUsePrfileStatus(userinfo.UserId);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            let rspns = response.body;
            console.log(this.getRegTyp);
            for (var x in rspns) {
              if (x != "ProfileNumber") {
                if (
                  (this.getRegTyp == 0 &&
                    x != "ExprienceDetail" &&
                    x != "PaymentStatus") ||
                  (this.getRegTyp == 3 && x != "ExprienceDetail" && x != "PaymentStatus") ||
                  (this.getRegTyp == 1 && x != "PaymentStatus") ||
                  (this.getRegTyp == 2 && x != "PaymentStatus") ||
                  (this.getRegTyp >= 4 && x != "PaymentStatus")
                ) {
                  //console.log(x, rspns[x]);
                  this.max++;
                  //Kms added on 7feb24
                  if (x != "ExprienceDetail" && x != "PaymentStatus") {
                    this.maxnew++;
                  }

                  if (rspns[x]) {
                    this.counter++;
                  }
                }
              }
            }
            //this.$session.set("counter", this.counter);

           sessionStorage.setItem("counter", this.counter);

            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    onClickButtonPayment(){
         this.$router.push("/Feesnewpayment");
    },
    CheckStatus() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUsePrfileStatus(userinfo.UserId);

      promiseU
        .then(response => {
          if (response.status == 200) {
            this.form = response.body;
            
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.getProfileStatus();
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    
   // this.counter = this.$session.get("counter");
    //this.counter = sessionStorage.getItem("counter");
 
    this.CheckStatus();
    this.getProfileStatus();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/Summary.vue